import React, { useEffect } from 'react';

const containerStyle = {
  position: 'fixed',
  top: 80,
  right: 24,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: 8,
  zIndex: 2000,
  pointerEvents: 'none', // do not block rest of UI
};

const toastStyle = {
  background: 'var(--card)',
  color: 'var(--text)',
  border: '1px solid var(--border)',
  borderRadius: 10,
  minWidth: 260,
  maxWidth: 360,
  boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
  padding: 12,
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  pointerEvents: 'auto', // allow click on the toast itself
};

const headerRow = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  fontWeight: 700,
};

const muted = { color: 'var(--muted)', fontSize: '0.9rem' };

const Toast = ({ id, waId, contactName, message, onClose, onOpen }) => {
  useEffect(() => {
    const t = setTimeout(() => onClose(id), 5000);
    return () => clearTimeout(t);
  }, [id, onClose]);

  const displayName = contactName || waId || 'Unknown';

  return (
    <div style={toastStyle}>
      <div style={headerRow}>
        <div>💬 New Message</div>
        <button className="btn" style={{ border: '1px solid var(--border)', padding: '2px 8px', fontSize: '0.9rem' }} onClick={() => onClose(id)}>✕</button>
      </div>
      <div>
        <div style={muted}>From</div>
        <div style={{ fontWeight: 600 }}>{displayName}</div>
        {contactName && waId && contactName !== waId && (
          <div style={{ ...muted, fontSize: '0.8rem', marginTop: 2 }}>{waId}</div>
        )}
      </div>
      <div>
        <div style={muted}>Message</div>
        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
          {message || 'New incoming message'}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}>
        <button className="btn btn-primary" onClick={() => onOpen(id, waId)}>Open Chat</button>
      </div>
    </div>
  );
};

const NotificationToasts = ({ items, onClose, onOpen }) => {
  if (!items || items.length === 0) return null;
  return (
    <div style={containerStyle}>
      {items.map((n) => (
        <Toast key={n.id} id={n.id} waId={n.wa_id} contactName={n.contact_name} message={n.message} onClose={onClose} onOpen={onOpen} />)
      )}
    </div>
  );
};

export default NotificationToasts;

